import type React from 'react';
import type { ReactElement } from 'react';

import { Error as ErrorIcon } from '../Icons/Paths/Error';
import { Tick } from '../Icons/Paths/Tick';
import { Warning } from '../Icons/Paths/Warning';

import styles from './Styles/Default.module.css';

type ToastVariant = 'primary' | 'secondary' | 'tertiary' | 'success' | 'warning' | 'error' | 'dark';
type ToastIconName = 'success' | 'error' | 'warning';
type ToastIcon = 'success' | 'error' | 'warning' | ReactElement;

export type ToastProps = {
  id?: string;
  children?: React.ReactNode;
  variant?: ToastVariant;
  icon?: ToastIcon;
  disabled?: boolean;
  inactive?: boolean;
};

const Icons: Record<ToastIconName, React.ComponentType> = {
  success: Tick,
  warning: Warning,
  error: ErrorIcon,
};

export const Toast = ({
  children,
  variant = 'primary',
  icon,
  disabled = false,
  inactive,
}: ToastProps) => {
  const getIcon = () => {
    if (typeof icon === 'string') {
      const IconComponent = Icons[icon as ToastIconName];
      return IconComponent ? <IconComponent /> : null;
    }
    return icon;
  };
  return (
    <div className={styles.wrapper} data-is-open={!!children} data-is-inactive={inactive}>
      <div className={styles.inner}>
        <div className={styles.toast} data-variant={variant} data-disabled={disabled}>
          {icon && <div className={styles.icon}>{getIcon()}</div>}
          <span className={styles.message}>{children} &nbsp;</span>
        </div>
      </div>
    </div>
  );
};
